module.exports = __webpack_public_path__ + "img/tapeInMethod.2aefe297.jpg";